import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const USER_ACTIVATE_GUEST_RESOURCE = "user" as const;
export const USER_ACTIVATE_GUEST_OPERATION = "activate-guest" as const;
export const USER_ACTIVATE_GUEST_API_PATH =
  `/v1/${USER_ACTIVATE_GUEST_RESOURCE}/${USER_ACTIVATE_GUEST_OPERATION}/{uuid}` as const;

export type MutationResponse =
  paths[typeof USER_ACTIVATE_GUEST_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useUserActivateGuestMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<MutationResponse, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      const response = await alphartisApiAxios.patch<MutationResponse>(
        `/v1/${USER_ACTIVATE_GUEST_RESOURCE}/${USER_ACTIVATE_GUEST_OPERATION}/${uuid}`,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [USER_ACTIVATE_GUEST_RESOURCE],
      });
    },
  });
};
